/**
 * « Démonstration » : le bandeau d'un bac à sable, sur tous les écrans.
 *
 * Il dit les deux choses qu'un prospect doit savoir avant de cliquer
 * « Envoyer » : l'entreprise est fictive, et rien ne sort — les envois sont
 * simulés par les Edge Functions (`_shared/demo.ts`). Il offre aussi de
 * repartir de zéro : un nouveau bac à sable pour le rendez-vous suivant,
 * l'ancien s'efface seul au bout de sept jours.
 */
import { useNavigate } from "react-router-dom";
import { CalendarClock, FlaskConical, RotateCcw } from "lucide-react";
import { useAuthStore } from "@/stores/authStore";
import { DEMO_BOOKING_URL } from "@/lib/constants";

export function DemoBanner() {
  const estAnonyme = useAuthStore((s) => s.authUser?.is_anonymous === true);
  const signOut = useAuthStore((s) => s.signOut);
  const navigate = useNavigate();

  if (!estAnonyme) return null;

  async function recommencer() {
    await signOut({ restartDemo: true });
    navigate("/demo", { replace: true });
  }

  return (
    <div
      role="status"
      className="flex flex-wrap items-center gap-x-3 gap-y-2 border-b border-accent/30 bg-accent/15 px-4 py-2.5 text-sm lg:px-6"
    >
      <FlaskConical size={16} className="text-text-primary flex-shrink-0" aria-hidden />
      <p className="flex-1 min-w-[14rem] text-text-secondary">
        <span className="font-medium text-text-primary">Démonstration.</span>{" "}
        Entreprise et clients fictifs&nbsp;: les envois sont simulés, aucun e-mail ne part. L’IA, elle, est réelle.
      </p>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
        <a
          href={DEMO_BOOKING_URL}
          target="_blank"
          rel="noopener"
          className="inline-flex items-center gap-1.5 font-medium text-text-primary underline underline-offset-2"
        >
          <CalendarClock size={14} aria-hidden />
          Prendre rendez-vous
        </a>
        <button
          type="button"
          onClick={() => void recommencer()}
          className="inline-flex items-center gap-1.5 font-medium text-text-secondary hover:text-text-primary"
        >
          <RotateCcw size={14} aria-hidden />
          Repartir de zéro
        </button>
      </div>
    </div>
  );
}
